export default __webpack_public_path__ + "static/media/back.2834c7bc.svg";